import type { JSX, ReactNode } from 'react';

import classNames from 'classnames';

import styles from './Container.module.css';

interface ContainerProps {
  children?: ReactNode;
  fluid?: boolean;
}

export default function Container({
  children,
  fluid,
  ...rest
}: ContainerProps): JSX.Element {
  return (
    <div
      {...rest}
      className={classNames(styles.Container, { [styles.fluid]: fluid })}
    >
      {children}
    </div>
  );
}
